import React from "react";
import { useSelector } from "react-redux";
import CpDbHOC from "@components/HOC/CpDbHOC";
import CrateCardV3 from "./CrateCardV3";
import OrderItemCard from "./OrderItemCard";

interface CrateCardProps {
  item: {
    product_image: string;
    name: string;
    original_quantity: number;
  };
  showIssueBtn?: boolean;
  navigation: any;
  isCpDb: boolean;
  isOfdCp: boolean;
  source?: string;
  type: string;
}

const CrateCard = (props: CrateCardProps) => {
  const { partialDeliveryEnabled = false } = useSelector(
    ({ configReducer }: any) => configReducer,
  );

  if (partialDeliveryEnabled && props.source === "PRE_DELIVERY") {
    return <OrderItemCard {...props} />;
  }
  return <CrateCardV3 {...props} />;
};

export default CpDbHOC(CrateCard);
